import { HttpClient, NonNullablePaths } from '@wix/sdk-types';
import {
  QueryServicesByFiltersOptions,
  QueryServicesByFiltersResponse,
  queryServicesByFilters as universalQueryServicesByFilters,
} from './bookings-catalog-search-v1-catalog-search-catalog-search.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/bookings' };

export function queryServicesByFilters(
  httpClient: HttpClient
): QueryServicesByFiltersSignature {
  return (options?: QueryServicesByFiltersOptions) =>
    universalQueryServicesByFilters(
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface QueryServicesByFiltersSignature {
  /**
   * Retrieves services from the catalog that match the given filters, each enriched with availability data.
   *
   * Applies location, resource type, and attribute filters, then narrows the catalog using the provided
   * WQL query. When a date range is specified in `serviceFilters`, only services with bookable slots in
   * that window are returned. Without a date range, all filtered services are returned, each marked as
   * available.
   *
   * To get complete result pages when filtering by availability, specify `query.cursorPaging`. Without it,
   * a single page of filtered results is returned without backfilling to the requested page size.
   */
  (options?: QueryServicesByFiltersOptions): Promise<
    NonNullablePaths<
      QueryServicesByFiltersResponse,
      | `results`
      | `results.${number}.service.type`
      | `results.${number}.service.category._id`
      | `results.${number}.service.form._id`
      | `results.${number}.service.payment.rateType`
      | `results.${number}.service.payment.addOnOption`
      | `results.${number}.service.bookingPolicy._id`
      | `results.${number}.service.taxableAddress.taxableAddressType`
      | `results.${number}.available`,
      6
    >
  >;
}

export {
  AddOnDetails,
  AddOnGroup,
  AddOnPaymentOptions,
  Address,
  AddressLocation,
  AddressStreetOneOf,
  Attribute,
  AttributeValueOneOf,
  AvailabilityConstraints,
  BookAfterStartPolicy,
  BookingPolicy,
  BusinessLocationOptions,
  CancellationFeePolicy,
  CancellationPolicy,
  CancellationWindow,
  CancellationWindowFeeOneOf,
  CatalogSearchResult,
  Category,
  CompletionRequirement,
  Conferencing,
  CursorPaging,
  CursorPagingMetadata,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Cursors,
  CustomLocationOptions,
  CustomOptions,
  CustomPayment,
  DailyConfig,
  DepositDetails,
  DepositDetailsValueOneOf,
  DiscountInfo,
  Duration,
  DurationRange,
  DurationRangeConfigOneOf,
  ExtendedFields,
  FirstChargeDateType,
  FixedPayment,
  Form,
  FormSettings,
  FrequencyType,
  FullUpfrontPayment,
  HourlyConfig,
  IntakeFormPolicy,
  Keyword,
  LimitEarlyBookingPolicy,
  LimitLateBookingPolicy,
  LimitRebookingPolicy,
  Location,
  LocationOptionsOneOf,
  LocationType,
  Media,
  MediaItem,
  MediaItemItemOneOf,
  Mode,
  Money,
  NumberRange,
  NumberValues,
  OnlineBooking,
  ParticipantsPolicy,
  Payment,
  PaymentOptions,
  PaymentRateOneOf,
  PhoneCall,
  PolicyDescription,
  QueryServicesByFiltersOptions,
  QueryServicesByFiltersRequest,
  QueryServicesByFiltersResponse,
  RankingOptions,
  RankingOrder,
  RateType,
  ReschedulePolicy,
  ResourceDetails,
  ResourceGroup,
  ResourceIds,
  ResourceInfo,
  ResourceType,
  ResourcesPolicy,
  SaveCreditCardPolicy,
  Schedule,
  SeoSchema,
  Service,
  ServiceFilters,
  ServiceResource,
  ServiceResourceSelectionOneOf,
  ServiceType,
  ServiceWithAvailability,
  Settings,
  Slug,
  SortOrder,
  Sorting,
  SortingMethodType,
  StaffMediaItem,
  StaffMediaItemItemOneOf,
  StaffMember,
  StaffMemberDetails,
  StaffSortingPolicy,
  StaffSortingPolicyOptionsOneOf,
  StreetAddress,
  SubscriptionPayment,
  Tag,
  TaxableAddress,
  TaxableAddressType,
  Timing,
  URLs,
  UnitType,
  VariedPayment,
  WaitlistPolicy,
  WorkingHours,
  WorkingHoursLocationCoverage,
} from './bookings-catalog-search-v1-catalog-search-catalog-search.universal.js';
